import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningBrandProfileApiService } from 'src/services/aiListeningApi/brandProfile'
import { BrandProfileDetail } from 'src/services/aiListeningApi/brandProfile.types'

// A profile (or one of its competitors) that is still being processed flips
// to ready on its own once the first check completes; poll until it does.
const PROCESSING_POLL_INTERVAL = 15000

const isProcessing = (profile?: BrandProfileDetail) =>
  profile?.state === 'processing' ||
  !!profile?.competitors?.some(
    (competitor) => competitor.state === 'processing'
  )

export const useGetAiListeningProfileQuery = (profileId?: string) => {
  return useQuery({
    enabled: !!profileId,
    queryFn: () =>
      AiListeningBrandProfileApiService.getProfile(profileId ?? ''),
    queryKey: [QueryKey.GET_AI_LISTENING_PROFILE, profileId],
    refetchInterval: (query) =>
      isProcessing(query.state.data) ? PROCESSING_POLL_INTERVAL : false,
  })
}
